import BaseEligibilityShow from "../../common/controllers/BaseEligibilityShow";

export default class BackofficeEligibilitiesShow extends BaseEligibilityShow {

    onStudyModalShow(e){
        console.log("MODLA SHOW")
        let $button = $(e.relatedTarget);
        let url = $button.data('url');

        console.log(url);
        console.log($button)

        super.onStudyModalShow(e);
    }
}